import React from 'react';

const PackageDataAndCollectiveUsage = ({packageType, packageCapacity, collectiveUsage}) => {
  return (
    <div className='package-data-and-collective-usage-container'>
      <div className='package-data-container'>
        <span className='package-type'>{packageType}</span>
        <div className='vertical-separator'></div>
        <span className='package-data'>{packageCapacity}</span>
      </div>
      <div className='collective-usage-container'>
        <span className='collective-usage-title'>ניצול משותף:</span>
        <span className='collective-usage-data'>{collectiveUsage}</span>
      </div>
    </div>
  );
};

export default PackageDataAndCollectiveUsage;
